import React, { FC } from 'react';

import { QuestionCircleOutlined } from '@ant-design/icons';

import MainLayout from '../../shared/common/components/layouts/MainLayout';
import PageHead from '../../shared/common/components/page-header/PageHeader';
import PartnerPage from '../../shared/common/components/partner/PartnerPage';
import { useActions } from '../../shared/common/hooks/useActions';

const Partner: FC = () => {
    const { setAppReportOpen, setDrawerLink } = useActions();

    const instructionBtn = (
        <span
            style={{
                marginLeft: 10,
                marginRight: 10,
                marginTop: 3,
                cursor: 'pointer',
            }}
            onClick={() => {
                try {
                    setDrawerLink('https://doc.scananalytics.ru/partnerka/partnerskij-kabinet/');
                    setAppReportOpen(true);
                } catch (err) {
                    console.error(err);
                }
            }}
        >
            <QuestionCircleOutlined
                style={{ color: '#ccc', fontSize: 14, marginTop: '8px', marginLeft: '-10px' }}
            />
        </span>
    );

    return (
        <MainLayout pageTitle="Партнерский кабинет">
            <div className="page-wrapper">
                <PageHead
                    title="2-х уровневая партнёрская программа"
                    extraContent={instructionBtn}
                />

                <div className="page-content">
                    <PartnerPage />
                </div>
            </div>
        </MainLayout>
    );
};

export default Partner;
